import 'rxjs/add/observable/of';
import { Injectable } from '@angular/core';
import { ProjectWithStats } from '../project';
import { DataSourceUtils } from '../../../shared/utils/data-source-utils';
import { getProjectsSelector, getProjectsTotalSelector } from '../projects.reducer';
import { GetProjectsWithStatsAction } from '../projects.action';

@Injectable()
export class ProjectsTableDataSource extends DataSourceUtils<ProjectWithStats> {
  protected params: {};

  update() {
    this.store.dispatch(new GetProjectsWithStatsAction(this.params));
  }

  onConnect() {
    this.params = {};
    return this.store.select(getProjectsSelector).withLatestFrom(this.store.select(getProjectsTotalSelector));
  }
}
